import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { debugLinkedInQueryKeys } from './queryKeys';

export function useDebugLinkedInAccountsQuery() {
  return useQuery({
    queryKey: debugLinkedInQueryKeys.accounts(),
    queryFn: async () => {
      const { data } = await fetchClient.GET('/debug/linkedin/accounts');
      return data ?? [];
    },
  });
}
